// extracted by mini-css-extract-plugin
export var legendIndicator = "_db-1";
export var legendRight = "_db-0";